import React, { useEffect, useState } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { SiteNav } from './SiteNav';
import { DiscordPopup } from './DiscordPopup';
import { useHashScroll } from '../hooks/useHashScroll';
export function SiteLayout() {
  const [progress, setProgress] = useState(0);
  const {
    pathname
  } = useLocation();
  useHashScroll();
  useEffect(() => {
    const onScroll = () => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      setProgress(max > 0 ? window.scrollY / max : 0);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, [pathname]);
  return <div className="min-h-screen w-full bg-[#050b14] text-gray-300 antialiased overflow-x-hidden" style={{
    fontFamily: "'Inter', sans-serif"
  }} data-id="element-1124" data-mp="3sjxljlizwj9t">
      <div className="fixed top-0 left-0 right-0 z-[60] h-0.5 origin-left bg-[#D4AF37]" style={{
      transform: `scaleX(${progress})`
    }} aria-hidden="true" data-id="element-1125" data-mp="1cuseojlk2wy" />
      <SiteNav data-id="element-1126" data-mp="3nlx5glrko558" />
      <Outlet data-id="element-1127" data-mp="3nmqczoycuyof" />
      <footer className="border-t border-white/5 bg-[#050b14] py-8" data-id="element-1128" data-mp="3nj2m6xkaoqde">
        <div className="max-w-7xl mx-auto flex flex-col items-center gap-4 px-5 text-xs text-gray-500 sm:flex-row sm:justify-between" data-id="element-1129" data-mp="3il9iqcadmagt">
          <nav aria-label="Secciones" className="flex gap-6 font-cinzel text-sm font-semibold" data-id="element-1130" data-mp="3dossncjm9m13">
            <Link to="/" className="transition-colors duration-150 hover:text-[#D4AF37]" data-id="element-1131" data-mp="38q9557pdk26m">Inicio</Link>
            <Link to="/guia" className="transition-colors duration-150 hover:text-[#D4AF37]" data-id="element-1132" data-mp="a83ilgktru6o">Guía</Link>
            <Link to="/proyeccion" className="transition-colors duration-150 hover:text-[#D4AF37]" data-id="element-1133" data-mp="59ilhq0vdqmg">Proyección</Link>
          </nav>
          <p data-id="element-1134" data-mp="3rnipqs6frlpg">© {new Date().getFullYear()} MU Vanguard</p>
        </div>
      </footer>
      <DiscordPopup data-id="element-1135" data-mp="swgygdps6gfm" />
    </div>;
}